/**
 * @generated SignedSource<<af7d1b1e3d36ee78b03a7eb9decf8ee9>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespUnavailableContainer_item$data = {
  readonly internalBuyLinks: ReadonlyArray<{
    readonly " $fragmentSpreads": FragmentRefs<"SharedRespLinksBlock_links">;
  } | null> | null;
  readonly isAuctionEnabled: boolean | null;
  readonly seller: {
    readonly isAccessible: boolean | null;
    readonly serviceId: string | null;
  } | null;
  readonly serviceId: string | null;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespSharedBreadcrumbs_item" | "PdpRespSharedHeroCarouselPrint_item" | "PdpRespSharedPrintDetailsLazy_item" | "PdpRespSharedQrCode_item" | "PdpRespSharedTitle_item" | "PdpRespUnavailableDetailsTabs_item" | "PdpRespUnavailableHeader_item" | "PdpRespUnavailableHeroCarousel_item" | "PdpRespUnavailableSidebarContact_item" | "PdpRespUnavailableSidebarSellerInfo_item" | "PdpSharedEditorialArticles_refactor_item" | "PdpSharedItemFavorites_item" | "PriceDisplay_item" | "SharedRespLinksBlock_item" | "usePdpSharedTracking_item">;
  readonly " $fragmentType": "PdpRespUnavailableContainer_item";
};
export type PdpRespUnavailableContainer_item$key = {
  readonly " $data"?: PdpRespUnavailableContainer_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespUnavailableContainer_item">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "serviceId",
  "storageKey": null
};
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "afterDisplay"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespUnavailableContainer_item",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isAuctionEnabled",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Seller",
      "kind": "LinkedField",
      "name": "seller",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isAccessible",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "InternalBuyLinkType",
      "kind": "LinkedField",
      "name": "internalBuyLinks",
      "plural": true,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "SharedRespLinksBlock_links"
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespSharedTitle_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "usePdpSharedTracking_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SharedRespLinksBlock_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespUnavailableHeader_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespSharedBreadcrumbs_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespUnavailableDetailsTabs_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespUnavailableHeroCarousel_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedEditorialArticles_refactor_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespSharedPrintDetailsLazy_item"
    },
    {
      "condition": "afterDisplay",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "PriceDisplay_item"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "PdpRespSharedQrCode_item"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "PdpSharedItemFavorites_item"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "PdpRespSharedHeroCarouselPrint_item"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "PdpRespUnavailableSidebarContact_item"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "PdpRespUnavailableSidebarSellerInfo_item"
        }
      ]
    }
  ],
  "type": "Item",
  "abstractKey": null
};
})();

(node as any).hash = "3d6864aed1a53fa4d4d79474c2bc51a1";

export default node;
